import React, { useState} from 'react';
import { useNavigate } from "react-router";
import Xmark from "../../assets/images/smallxmark.png";
import searchIcon from "../../assets/images/Search.png";
import "./selectCurrency.css"
import { securrencys } from '../NewTrip';
import { useDispatch } from 'react-redux';
import { updateCurrency } from '../../redux/features/tripFormSlice';


export default function SelectCurrencyModal({handleClose, handleChange}) {

  const dispatch = useDispatch();
  const [selectedCurenncy, setselectedCurency] = useState()

//   const selectedCurrency = (currency) => {
//     selectedCurrency(currency)
//   }
  const handleSelectedCurency = (e, value) => {
    setselectedCurency(value)
    handleChange(e, value)
  }

  const saveCurrency = () => {
    // dispatch(updateCurrency(selectedCurenncy))
    handleClose()
  }
  return (
    <div>
          <div className='select_currency_container'>
          <div className="new-place-top">
          <p className="title2" style={{margin: "10px 0" }}>
            Select currency
          </p>
          <img src={Xmark} alt="close" onClick={() => handleClose()}/>
        </div>
        <div
          className="serch-input"
          style={{ width: "100%", height: "47px", marginTop: "1.7rem" }}
        >
          <img src={searchIcon} alt="search" style={{ paddingLeft: "5px" }} />
          <input
            className="search-place"
            name="destination"
            placeholder="Search currency"
              />
             
          </div>
          
          {securrencys.map(currency =>
            
              <div className='currency-items'>
                  <div className='currency-item'>
                  <input type="radio" name='securrency' value={currency.value} onChange={(e)=>handleSelectedCurency(e, currency)} />{currency.curryncyTag}<span className='body3' style={{color:"var(--gray80)", margin:"0"}}>{currency.value}</span>
                  </div>
                  
             </div>)}
      </div>
        <footer className="create-button-save" style={{height:"56px", width:"100%",padding: "8px 0"}}>
        <button
          className="btn-create"
          variant="contained"
          style={{ width: "90%", backgroundColor:"#00857D", color:"#FFFFFF"}}
          type="submit"
          fullWidth
          onClick={() => saveCurrency()}
        >
          Save
        </button>
    </footer> 
        </div>
        
  )
}